import { useEffect, useRef, useState } from "react";

export const useDoOnce = (doThis, boolean) => {
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (!done && boolean) {
      doThis();
      setDone(true);
    }
  }, [boolean, done, doThis]);
};

export const usePrevious = (value) => {
  const ref = useRef();

  // Store current value in `ref`.
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes.

  // Return previous value (happens before update in useEffect above).
  return ref.current;
};
